export class SednaSetupModel {
  hotel_id: number;
  grant_type_delegation_client_id: string;
  grant_type_delegation_client_secret: string;
  grant_type_password_client_id: string;
  grant_type_password_client_secret: string;
  scope: string;
  api_key: string;
  test_mode: boolean;
  company_id: string;

  constructor(hotel_id = +JSON.parse(localStorage.getItem('token_form')).app_hotel_id,
              grant_type_delegation_client_id = '',
              grant_type_delegation_client_secret = '',
              grant_type_password_client_id = '',
              grant_type_password_client_secret = '',
              scope = '',
              api_key = '',
              test_mode = false,
              company_id = '') {
    this.hotel_id = hotel_id;
    this.grant_type_delegation_client_id = grant_type_delegation_client_id;
    this.grant_type_delegation_client_secret = grant_type_delegation_client_secret;
    this.grant_type_password_client_id = grant_type_password_client_id;
    this.grant_type_password_client_secret = grant_type_password_client_secret;
    this.scope = scope;
    this.api_key = api_key;
    this.test_mode = test_mode;
    this.company_id = company_id;

  }
}
